const Pages = {
    CategoryLanding: 'category_landing',
    Checkout: 'checkout',
    UserLogin: 'login',
    Home: 'home',
    Subcategory: 'subcategory',
    Product: 'product_page',
    UserAddress: 'addresses',
    UserClub: 'club',
    UserCards: 'cards',
    UserRegister: 'user_register',
    UserReviews: 'user_reviews',
    UserWarranty: 'user_warranty',
    UserOrderReturn: 'user_order_return',
};

const TranslationsKeys = {
    [Pages.Checkout]: [
        'checkout',
        'adyen',
        'countries',
        'states',
        'footer',
        'header.login_from',
        'meta_data.checkout',
        'form',
        'register',
        'forgotpassword',
    ],
    [Pages.Product]: [
        'generic',
        'meta_data',
        'product_page',
        'cart_page',
        'header',
        'geo_ip',
        'footer',
        'countries',
        'subscribe',
        'form',
        'register',
        'forgotpassword',
        'reviews.reviews_popup',
    ],
    [Pages.Home]: [
        'generic',
        'meta_data',
        'cart_page',
        'header',
        'geo_ip',
        'footer',
        'countries',
        'subscribe',
        'reviews.reviews_popup',
        'home_page',
        'form',
        'register',
        'forgotpassword',
        'restorepassword',
        'states',
    ],
    [Pages.Subcategory]: [
        'generic',
        'meta_data',
        'catalog',
        'category_page.title',
        'category_page.url',
        'cart_page',
        'form',
        'header',
        'geo_ip',
        'footer',
        'countries',
        'subscribe',
        'register',
        'forgotpassword',
    ],
    [Pages.UserAddress]: [
        'user',
        'countries',
        'states',
        'meta_data',
        'header',
        'geo_ip',
        'footer',
        'form',
        'cart_page',
        'register',
        'forgotpassword',
    ],
    [Pages.UserClub]: [
        'user',
        'countries',
        'states',
        'meta_data',
        'header',
        'geo_ip',
        'footer',
        'form',
        'cart_page',
        'register',
        'forgotpassword',
    ],
    [Pages.UserCards]: [
        'user',
        'meta_data',
        'header',
        'countries',
        'geo_ip',
        'footer',
        'form',
        'cart_page',
        'register',
        'forgotpassword',
    ],
    [Pages.CategoryLanding]: [
        'generic',
        'meta_data',
        'category_page.landing',
        'category_page.url.more_brands',
        'category_page.title.shop',
        'cart_page',
        'form',
        'header',
        'geo_ip',
        'footer',
        'countries',
        'subscribe',
        'register',
        'forgotpassword',
    ],
    [Pages.UserRegister]: [
        'user.menu.register',
        'form',
        'register',
        'forgotpassword',
        'geo_ip',
    ],
    [Pages.UserLogin]: [
        'header.login_from',
        'form',
        'register',
        'forgotpassword',
        'geo_ip',
    ],
    [Pages.UserReviews]: [
        'user.reviews',
        'user.menu',
        'countries',
        'meta_data',
        'header',
        'geo_ip',
        'footer',
        'cart_page',
        'reviews.reviews_popup',
    ],
    [Pages.UserWarranty]: [
        'user.warranty',
        'user.menu',
        'countries',
        'meta_data',
        'header',
        'geo_ip',
        'footer',
        'cart_page',
    ],
    [Pages.UserOrderReturn]: [
        'form',
        'user.order',
        'user.returns.order',
        'user.menu',
        'countries',
        'meta_data',
        'header',
        'geo_ip',
        'footer',
        'cart_page',
    ],
};

const getKeys = (page) => TranslationsKeys[page].join(',') || null;
const Translations = { getKeys };

export { Pages as TranslationPages };
export default Translations;
